export enum AddNewMedicineFieldName {
  IntakeRegime = "intakeRegime",
  IntakePartOfDay = "intakePartOfDay",
  Inn = "inn",
  Type = "type",
  Name = "name",
}
